import React from "react"
import autobind from "class-autobind"
import ContentFilterList from "material-ui/svg-icons/content/filter-list"
import { SelectField, MenuItem } from "material-ui"
import strings from "../../localization/strings"
import { ISelectedFilterTemplateId, IFilter, EDefaultFilterValues } from "../../models"
import AddFilterTemplateDialog from "./AddFilterTemplateDialog"

interface IProps {
    addFilterTemplateLabel: string
    editFilterTemplateLabel: string
    filterTemplates: IFilter[]
    selectedFilterTemplateId: ISelectedFilterTemplateId
    style?: React.CSSProperties
    handleSave(name: string): void
    handleSelectFilterTemlate(selectedFilterTemplateId: ISelectedFilterTemplateId): void
    handleDeleteFilterTemplate(filterTemplateId: string): void
    children: React.ReactElement
}
interface IState {
    openAddFilterTemplateDialog: boolean
    editFilterTemplate: IFilter
}

export default class FilterTemplate extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddFilterTemplateDialog: false,
            editFilterTemplate: null
        }
        autobind(this)
    }

    render() {
        return (
            <div style={{ display: "flex", alignItems: "center", ...this.props.style }}>
                <ContentFilterList
                    data-intercom-target={"menu-Employees-Filter-Btn-CreateOrEditFilter"}
                    style={{ cursor: "pointer", width: "30px", marginRight: "10px" }}
                    onClick={() => this.setState({
                        openAddFilterTemplateDialog: true,
                        editFilterTemplate: (this.props.selectedFilterTemplateId === EDefaultFilterValues.CREATE_NEW || this.props.selectedFilterTemplateId === EDefaultFilterValues.NONE) ? null :
                            this.props.filterTemplates.find(i => i.Id === this.props.selectedFilterTemplateId)
                    })}
                />
                <SelectField
                    floatingLabelText={strings.Filter_Template}
                    value={this.props.selectedFilterTemplateId}
                    onChange={(event, key, value) => {
                        value === EDefaultFilterValues.CREATE_NEW &&
                            this.setState({ openAddFilterTemplateDialog: true, editFilterTemplate: null })
                        this.props.handleSelectFilterTemlate(value)
                    }}
                    style={{ width: 300 }}
                >
                    {this.props.filterTemplates.map((filter, index) =>
                        <MenuItem
                            innerDivStyle={{ borderBottom: index === this.props.filterTemplates.length - 1 ? "0.5px solid grey" : "none" }}
                            key={filter.Id} value={filter.Id}
                            primaryText={filter.Name}
                        />
                    )}
                    <MenuItem value={EDefaultFilterValues.NONE} primaryText={strings.None} />
                    <MenuItem data-intercom-target={"menu-Employees-Filter-Btn-CreateNewFilter"} value={EDefaultFilterValues.CREATE_NEW} primaryText={strings.Create_New_Filter} />
                </SelectField>
                {this.state.openAddFilterTemplateDialog &&
                    <AddFilterTemplateDialog
                        addFilterTemplateLabel={this.props.addFilterTemplateLabel}
                        editFilterTemplateLabel={this.props.editFilterTemplateLabel}
                        editFilterTemplate={this.state.editFilterTemplate}
                        existingFilterTemplates={this.props.filterTemplates}
                        handleSave={name => {
                            this.props.handleSave(name)
                            this.setState({ openAddFilterTemplateDialog: false, editFilterTemplate: null })
                        }}
                        handleClose={() => this.setState({ openAddFilterTemplateDialog: false, editFilterTemplate: null })}
                        handleDeleteFilterTemplate={filterTemplateId => {
                            this.props.handleDeleteFilterTemplate(filterTemplateId)
                            this.setState({ openAddFilterTemplateDialog: false, editFilterTemplate: null })
                        }}
                    >
                        {this.props.children}
                    </AddFilterTemplateDialog>
                }
            </div>
        )
    }
}